var map = {
	"./en/example.yml": 154,
	"./en/hos.yml": 155,
	"./en/main.yml": 30,
	"./en/markdown.yml": 156,
	"./en/news.yml": 157,
	"./en/sfs.yml": 158,
	"./fr/example.yml": 159,
	"./fr/hos.yml": 160,
	"./fr/main.yml": 31,
	"./fr/markdown.yml": 161,
	"./fr/news.yml": 162,
	"./fr/sfs.yml": 163,
	"./hr/hos.yml": 164,
	"./hr/main.yml": 32,
	"./hr/sfs.yml": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;